'use strict';

export const FALL = 'Fall';
export const WINTER = 'Winter';
export const SPRING = 'Spring';
